import React, { useState } from "react";
import { Button, Radio, Toast } from 'react-vant';
import { DatePicker,message } from 'antd';
import './ai.scss';
import 'animate.css';
import "../../chat/animate/slide_top.css";
import "../../chat/animate/slide_in_left.css";
import fill_in_information from '../../../assets/update_new/fill_in_information_icon.svg';
import arrow_right from '../../../assets/update_new/arrow_right.svg';
import dayjs from 'dayjs';

import love from '../../../assets/update_new/love_option.svg';
import career from '../../../assets/update_new/carrer_option.svg';
import wealth from '../../../assets/update_new/waalth_option.svg';
import family from '../../../assets/update_new/family_option.svg';
const Ai = ({ avatar, code, content, showFillInInformation, clickBirthPlace, confirmInfoData, country, city,setCalculationType }) => {
    const [gender, setGender] = useState('Male');
    const [bloodType, setBloodType] = useState('A');
    const [birthday, setBirthday] = useState(dayjs(new Date(1999, 0, 1)));
    const [birthdayString, setBirthdayString] = useState('1999-01-01 00:00:00');

    const BirthPlaceStatus = () => {
        clickBirthPlace(true);
    }
    const confirmInfo = () => {
        if (!birthdayString || !city) {
            message.info('Please fill in everything');
            return
        }
        const infoData = {
            gender: gender,
            bloodType: bloodType,
            birthday: birthdayString,
        }
        confirmInfoData(infoData)

    }
    const textColor = (country && city) ? '#000000' : '#0000004f';

    return (
        <div className="ai_content slide-in-left">
            <img src={avatar} className="ai_avatar"></img>
            <div className="ai_message_div">
                <span className="ai_text" dangerouslySetInnerHTML={{ __html: content }} />
                {(code == '1002' || code == '2001' || code == '3001' || code == '3002') && (
                    <div>
                        <div onClick={showFillInInformation}
                            className="ai_fill_in_information"
                        >
                            <img className="ai_fill_in_information_icon" src={fill_in_information}></img>
                            <span className="ai_fill_in_information_text" >Tell me, when were you born?</span>
                            <img className="ai_fill_in_information_arrow" src={arrow_right}></img>
                        </div>
                        <div className="pc_FillInfo">
                            <div className="fill_in_div">
                                <span className="fill_in_title">Gender :</span>
                                <Radio.Group className="radio_group" value={gender} onChange={(e) => setGender(e)} direction="horizontal" checkedColor="#F4A632" iconSize="16px" >
                                    <Radio className="radio" name="Male">Male</Radio>
                                    <Radio className="radio" name="Female">Female</Radio>
                                    <Radio className="radio" name="Other">Other</Radio>
                                </Radio.Group>
                            </div>
                            <div className="fill_in_div">
                                <span className="fill_in_title">Blood Type :</span>
                                <Radio.Group className="radio_group" value={bloodType} onChange={(e) => setBloodType(e)} direction="horizontal" checkedColor="#F4A632" iconSize="16px" >
                                    <Radio className="radio" name="A">A</Radio>
                                    <Radio className="radio" name="B">B</Radio>
                                    <Radio className="radio" name="O">O</Radio>
                                    <Radio className="radio" name="AB">AB</Radio>
                                </Radio.Group>
                            </div>
                            <div className="fill_in_div">
                                <span className="fill_in_title">Birthday :</span>
                                <DatePicker
                                    showTime
                                    className="date_picker"
                                    value={birthday}
                                    onChange={(value, dateString) => {
                                        setBirthday(value ? value : null)
                                        setBirthdayString(dateString)
                                    }}
                                />
                            </div>
                            <div className="fill_in_div">
                                <span className="fill_in_title">Birthplace :</span>
                                <span className="birthplace" style={{ color: textColor }} onClick={BirthPlaceStatus}>{(country && city) ? city + " " + country : "Select your country and city"}</span>
                            </div>
                            <span className="fill_in_confirm" onClick={confirmInfo}>Confirm</span>
                        </div>
                        <div className="ai_fill_in_information_tips" >
                            <span><span style={{ color: '#000000',fontWeight:'bold' }}>Tips:</span> Your privacy is protected in line with our policy, Please feel confident providing your information.</span>
                        </div>
                    </div>
                )}
                {(code == '1111' && (
                    <div style={{ marginTop: '15px' }}>
                        <img src={love} style={{ marginRight: '10px',marginBottom:'5px',cursor:'pointer' }} onClick={() => setCalculationType('love')}></img>
                        <img src={career} style={{ marginRight: '10px',marginBottom:'5px',cursor:'pointer' }} onClick={() => setCalculationType('career')}></img>
                        <img src={wealth} style={{ marginRight: '10px',marginBottom:'5px',cursor:'pointer' }} onClick={() => setCalculationType('wealth')}></img>
                        <img src={family} style={{ marginRight: '10px',marginBottom:'5px',cursor:'pointer' }} onClick={() => setCalculationType('family')}></img>
                    </div>
                ))}
            </div>
        </div>
    )
}
export default Ai;